var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m21 10a1 1 0 0 0 -2 0 7 7 0 0 1 -14 0 1 1 0 0 0 -2 0 9.01 9.01 0 0 0 8 8.941v3.059h-2a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2h-2v-3.059a9.01 9.01 0 0 0 8-8.941z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m12 15a5.006 5.006 0 0 0 5-5v-5a5 5 0 0 0 -10 0v5a5.006 5.006 0 0 0 5 5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicro);
export default __webpack_public_path__ + "static/media/micro.0b94a57d4c23263652137fb30ea27674.svg";
export { ForwardRef as ReactComponent };